import { Component, OnInit, Input } from '@angular/core';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { NavController, Refresher,LoadingController,ToastController,NavParams,AlertController} from 'ionic-angular';
import { PedidoDAO } from '../../daos/pedido-dao';
import { DTOAcompanharPedido } from '../../dto/dtoAcompanharPedido';
import { DTOAcompanharPix } from '../../dto/dtoAcompanharPix';
import { VisualizaImagemPage } from '../../pages/visualiza-imagem/visualiza-imagem';
import { LogPedido } from '../../entities/logPedido';
import { LogPix } from '../../entities/logPix';
import { AppModule } from '../../app/app.module';
import { Empresa } from '../../entities/empresa';
import { OrdemPagamentoPage } from '../../pages/ordem-pagamento/ordem-pagamento';


//import _ from 'lodash';

declare var require: any;

@Component({
    selector: 'liberacao-pedido',
    templateUrl: './liberacao-pedido.html'
})
export class LiberacaoPedidoComponent implements OnInit  {
    @Input('usuario') usuario: DTOInformacaoUsuario;
    public acompanharPedido: DTOAcompanharPedido[] = [];
    public acompanharPix: DTOAcompanharPix[] = [];
    public logPedido: LogPedido = new LogPedido();
    public logPix: LogPix = new LogPix();
    public empresaLogada : Empresa = new Empresa();
    segmento: string = "pedidos";
    //public url: string="https://api.whatsapp.com/send/?phone=5585986902230&text=seu%20pedido%20foi%20aprovado";
    constructor(public navCtrl: NavController,private _loadingCtrl: LoadingController,
        private _toastCtrl: ToastController,private _alertCtrl: AlertController
        ,private _pedidoDao: PedidoDAO,_navParams: NavParams) {             
        
    }

    ngOnInit(): void {
        this.empresaLogada =  AppModule.getEmpresa(); 

        if (this.usuario.Perfil == 'ADMINISTRADOR'){
            this.obterAcompanhamentoPedido();
            this.obterAcompanhamentoPix();
        }
        
    }


    async copiar(texto) {
        if (navigator["clipboard"]) {
        try {
        await navigator["clipboard"].writeText(texto);
            } catch (err) {}
        }
    }

    public obterAcompanhamentoPix(refresher?: Refresher): void {
        let load = this._loadingCtrl.create({ content: 'Obtendo Acompanhamento...' });
        if (!refresher)
            load.present();
            this._pedidoDao.listaPix(this.empresaLogada.Id, 0,true,'2025-10-01','2025-10-01','0').then(lstPix => {        
            this.acompanharPix = lstPix; // lstPedido.filter(item => _.isEqual(item.Status, 'Em Análise'));  

    
            if (!refresher) load.dismiss(); else refresher.complete();
        }).catch(error => {
            console.error(error);
            if (!refresher) load.dismiss(); else refresher.complete();
            this._toastCtrl.create({
                message: 'Ocorreu um erro ao tentar obter os acompanhamento pix. Tente novamente!',
                duration: 3000
            }).present();        
        });
    
    }

    public obterAcompanhamentoPedido(refresher?: Refresher): void {
        let load = this._loadingCtrl.create({ content: 'Obtendo Acompanhamento...' });
        if (!refresher)
            load.present();
            this._pedidoDao.listaPedido(this.empresaLogada.Id, 0,true,'2025-10-01','2025-10-01','0').then(lstPedido => {        
            this.acompanharPedido = lstPedido; // lstPedido.filter(item => _.isEqual(item.Status, 'Em Análise'));  

    
            if (!refresher) load.dismiss(); else refresher.complete();
        }).catch(error => {
            console.error(error);
            if (!refresher) load.dismiss(); else refresher.complete();
            this._toastCtrl.create({
                message: 'Ocorreu um erro ao tentar obter os acompanhamento pedido. Tente novamente!',
                duration: 3000
            }).present();        
        });
    
    }

    visualizarImagem(obj:string){
        this.navCtrl.push(VisualizaImagemPage,{usu: this.usuario, img: obj  });
    }

    public visualizarInfoPedido(dtoAcompanharPedido: DTOAcompanharPedido): void {
        if (dtoAcompanharPedido.VeInfoPedido == undefined)
            dtoAcompanharPedido.VeInfoPedido = true;
        else if (dtoAcompanharPedido.VeInfoPedido)
            dtoAcompanharPedido.VeInfoPedido = false;
        else dtoAcompanharPedido.VeInfoPedido = true ;
        
    }

    public visualizarInfoPix(dtoAcompanharPix: DTOAcompanharPix): void {
        if (dtoAcompanharPix.VeInfoPix == undefined)
            dtoAcompanharPix.VeInfoPix = true;
        else if (dtoAcompanharPix.VeInfoPix)
            dtoAcompanharPix.VeInfoPix = false;
        else dtoAcompanharPix.VeInfoPix = true ;
        
    }

    alertaDeAviso(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Atenção ⚠️',
            buttons: [{
                text: 'Ok'
            }]
        }).present();
    }

    alertaDeSucesso(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Sucesso 😀 ️',
            buttons: [{
                text: 'Ok'
            }]
        }).present();
    }

    alertaErro(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Ops... 😔',
            buttons: [{
                text: 'Ok, estou ciente'
            }]
        }).present();
      }

    public liberarPedido(item): void {        
        this.logPedido.Empresa = AppModule.getEmpresa();
        this.logPedido.NumPedido = item.NumPedido ;
        this.logPedido.Status = 'A';
        this.logPedido.Obs = '';

        this._pedidoDao.criarLogPedido(this.logPedido)
            .then(r => {
                this.alertaDeSucesso('Pedido Liberado!');
            }, err => {
                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
            });             
   
            const index = this.acompanharPedido.indexOf(item);
            this.acompanharPedido.splice(index, 1);        
    }

    public recusarPedido(item): void {    
        this._alertCtrl.create({
            title: 'Têm certeza que deseja recusar o pedido?',
            subTitle: `Após a confirmação, o pedido ${item.NumPedido}  será cancelado.`,
            inputs: [
                {
                    name: 'Obs',
                    type:"text",
                    placeholder: 'Informe a observação...' 
    
                },
            ],
            buttons: [
                {
                    text: 'Não',
                    role: 'destructive'
                },
                {
                    text: 'Sim',
                    handler: (data) => {
                        if (data.Obs.length == 0) {
                            this.alertaDeAviso('Observação é obrigatório!');
                            return;
                        }
                      
                        this.logPedido.Empresa = AppModule.getEmpresa();
                        this.logPedido.NumPedido = item.NumPedido;
                        this.logPedido.Status = 'C';
                        this.logPedido.Obs = data.Obs;
                        this.logPedido.PrimeiraCartela = item.PrimeiraCartela;
                        this.logPedido.SegundaCartela = item.SegundaCartela;
                
                        this._pedidoDao.criarLogPedido(this.logPedido)
                            .then(r => {
                                this.alertaErro('Pedido Cancelado!');

                                const index = this.acompanharPedido.indexOf(item);
                                this.acompanharPedido.splice(index, 1);

                            }, err => {
                                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
                            });   
                        
                    }
                }
            ]
        }).present();          
        
    }

    public autorizarPix(item): void {   
        this.logPix.Empresa = AppModule.getEmpresa();
        this.logPix.NumSolicitacao = item.NumSolicitacao;
        this.logPix.Status = 'L';
        this.logPix.Obs = '';
        this.logPix.PrimeiraCartela = item.PrimeiraCartela;
        this.logPix.SegundaCartela = item.SegundaCartela;       


        this._pedidoDao.criarLogPix(this.logPix)
            .then(r => {
                this.alertaDeSucesso('Pix marcado como autorizado.');
            }, err => {
                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
            });             
   
            const index = this.acompanharPix.indexOf(item);
            this.acompanharPix.splice(index, 1);        
    }


    public liberarPix(item): void {   
        this.logPix.Empresa = AppModule.getEmpresa();
        this.logPix.NumSolicitacao = item.NumSolicitacao;
        this.logPix.Status = 'T';
        this.logPix.Obs = '';
        this.logPix.PrimeiraCartela = item.PrimeiraCartela;
        this.logPix.SegundaCartela = item.SegundaCartela;       


        this._pedidoDao.criarLogPix(this.logPix)
            .then(r => {
                this.alertaDeSucesso('Pix marcado como transferido.');
            }, err => {
                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
            });             
   
            const index = this.acompanharPix.indexOf(item);
            this.acompanharPix.splice(index, 1);        
    }

    public ImprimirPdfTodasSolicitacoes(): void {
        // 1. Filtra apenas os registros que estão 'Em Análise'
        const pixEmAnalise = this.acompanharPix ? this.acompanharPix.filter(pix => pix.Status === 'Em Análise') : [];
   

        if (pixEmAnalise.length === 0) {
            this.alertaDeAviso('Não há solicitações de Pix "Em Análise" disponíveis para impressão.');
            return;
        }

        const jsPDF = require('jspdf');
        require('jspdf-autotable');

        // Cria o documento em formato paisagem ('l'), unidades em pontos ('pt'), tamanho A4
        const doc = new jsPDF.default('l', 'pt', 'a4');

        // 2. Título do Relatório
        doc.setFontSize(14);
        doc.text('SOLICITAÇÃO DE REALIZAÇÃO DE PAGAMENTO - BRINDE PIX (EM ANÁLISE)', 40, 40);

        // 3. Empresa logada
        doc.setFontSize(10);
        doc.text(`Empresa: ${this.empresaLogada ? this.empresaLogada.Descricao : 'N/A'}`, 40, 60);

        // 4. Mapeando os dados da lista filtrada `pixEmAnalise`
        const dadosTabela = pixEmAnalise.map(pix => {
            let observacao = pix.Obs || '';
            observacao = observacao.replace(/nome\s*titular\s*:?/gi, '').replace(/titular\s*:?/gi, '').trim();

            return [
                pix.NumSolicitacao || '',
                pix.NomeRepresentante || '',            
                `${pix.PrimeiraCartela || ''} / ${pix.SegundaCartela || ''}`,
                observacao,            
                `${pix.TipoChavePix || ''}: ${pix.ChavePix || ''}`,
                pix.NomeEmpresaVendedor || '',
                pix.NomeBanco || '',
                pix.VlrPix ? `R$ ${pix.VlrPix}` : ''
            ];
        });

        // 5. Cálculo do Valor Total considerando apenas os filtrados
        let valorTotal = 0;
        pixEmAnalise.forEach(pix => {
            if (pix.VlrPix) {
                let valorNumerico = parseFloat(String(pix.VlrPix).replace('R$', '').replace(/\./g, '').replace(',', '.').trim());
                if (!isNaN(valorNumerico)) {
                    valorTotal += valorNumerico;
                }
            }
        });

        const valorTotalFormatado = valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        // 6. Configuração e Geração da Tabela com jspdf-autotable
        doc.autoTable({
            startY: 75,
            head: [[
                'Nº Solicitação', 
                'Representante',                
                'Cartelas', 
                'Titular',                
                'Chave Pix', 
                'Cliente', 
                'Banco', 
                'Valor'
            ]],
            body: dadosTabela,
            foot: [[
                { 
                    content: 'Valor Total:', 
                    colSpan: 7, 
                    styles: { halign: 'right', fontStyle: 'bold', fillColor: [240, 240, 240], textColor: [0, 0, 0] } 
                },
                { 
                    content: valorTotalFormatado, 
                    styles: { fontStyle: 'bold', fillColor: [240, 240, 240], textColor: [0, 0, 0] } 
                }
            ]],
            theme: 'grid',
            headStyles: { fillColor: [41, 128, 185] },
            styles: { fontSize: 9, cellPadding: 6 },
            columnStyles: {
                0: { cellWidth: 70 },
                1: { cellWidth: 120 },                
                2: { cellWidth: 70 },
                3: { cellWidth: 180 },                
                4: { cellWidth: 110 },
                5: { cellWidth: 100 },
                6: { cellWidth: 70 },
                7: { cellWidth: 70 }
            }
        });

        // ==========================================
        // 7. SEÇÃO DE ASSINATURAS E AUTORIZAÇÕES
        // ==========================================
        
        let finalY = doc.lastAutoTable.finalY || 150;
        let posY = finalY + 45;

        if (posY > 480) {
            doc.addPage();
            posY = 80;
        }

        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');
        doc.text('Assinatura / Autorização:', 40, posY);

        posY += 40;

        const colWidth = 220;
        const startX = 40;
        const gap = 31;

        const assinaturas = [
            'Departamento Comercial',
            'Diretoria',
            'Contas a Pagar (Rec. em ____/____/________)'
        ];

        doc.setFont(undefined, 'normal');
        doc.setFontSize(9);

        assinaturas.forEach((cargo, index) => {
            // Correção aplicada aqui (* no lugar de parêntese)
            const xLineStart = startX + (index * (colWidth + gap));
            const xLineEnd = xLineStart + colWidth;
            const xCenter = xLineStart + (colWidth / 2);
            
            doc.line(xLineStart, posY, xLineEnd, posY);
            doc.text(cargo, xCenter, posY + 15, { align: 'center' });
        });

        // 8. Salva o arquivo PDF gerado
        doc.save('Solicitacao-Pagamento-Brinde-Pix-Em-Analise.pdf');
    }

    

    public GerarRelatorio(item): void { 
        this.navCtrl.push(OrdemPagamentoPage,{usu: this.usuario,acompanharPix: item});  
        //if (window) {
        //window.print();
        //} else {
        //console.warn("window object not available for printing.");
        //}
    }


    public recusarPix(item): void {    
        this._alertCtrl.create({
            title: 'Têm certeza que deseja recusar o pix?',
            subTitle: `Após a confirmação, a solicitação nº ${item.NumSolicitacao} será cancelada.`,
            inputs: [
                {
                    name: 'Obs',
                    type:"text",
                    placeholder: 'Informe a observação...' 
    
                },
            ],
            buttons: [
                {
                    text: 'Não',
                    role: 'destructive'
                },
                {
                    text: 'Sim',
                    handler: (data) => {
                        if (data.Obs.length == 0) {
                            this.alertaDeAviso('Observação é obrigatório!');
                            return;
                        }


                      
                        this.logPix.Empresa = AppModule.getEmpresa();
                        this.logPix.NumSolicitacao = item.NumSolicitacao;
                        this.logPix.Status = 'C';
                        this.logPix.Obs = data.Obs;
                        this.logPix.PrimeiraCartela = item.PrimeiraCartela;
                        this.logPix.SegundaCartela = item.SegundaCartela;
                
                        this._pedidoDao.criarLogPix(this.logPix)
                            .then(r => {
                                this.alertaErro('Pix Cancelado!');

                                const index = this.acompanharPix.indexOf(item);
                                this.acompanharPix.splice(index, 1);

                            }, err => {
                                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
                            });  
                                             
                        
                        
                    }
                }
            ]
        }).present();

                 
        
    }


}


// WEBPACK FOOTER //
// ./src/components/liberacao-pedido/liberacao-pedido.ts